module.exports = __webpack_public_path__ + "media/directory/location_icon_black-de72f2be.svg";